import { API } from '@aws-amplify/api';
import { CampusSurveyExport } from '../../@types/subjectSurvey';

export interface GetCampusSurveyDataInput {
  campusId: string;
}

export async function getCampusSurveyData(
  input: GetCampusSurveyDataInput
): Promise<CampusSurveyExport> {
  try {
    const apiName = process.env.NEXT_PUBLIC_ONBOARDING_API_NAME!;
    const path = 'api/subject-survey/campus-data';
    const myInit = {
      headers: {},
      queryStringParameters: {
        campusId: input.campusId,
      },
    };

    const response = await API.get(apiName, path, myInit);
    return response;
  } catch (error) {
    console.error('Error getting campus survey data:', error);
    throw error;
  }
}
